import { notifications } from '@mantine/notifications';
import { IconCheck } from '@tabler/icons-react';

export const notifySuccess = (title: string, message?: string) => {
  notifications.show({
    title,
    message,
    color: 'teal',
    icon: <IconCheck size={18} />,
    autoClose: 3000,
  });
};
